





import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'upload-button',
})
export default class UploadButton extends Vue {
  @Prop() selectedCallback: (arg: any) => {};
  @Prop() title: string;

  fileSelected(e: any) {
    if (this.selectedCallback) {
      if (e.target.files[0]) {
        this.selectedCallback(e.target.files[0]);
      } else {
        this.selectedCallback(null);
      }
    }
  }
}
